import { createEntityAdapter } from '@reduxjs/toolkit';
import { AdSlotParams } from './adslots.types';

const adapter = createEntityAdapter<AdSlotParams>();

export default adapter;
